import plugin from '../src/helpers.plugin.js';

(typeof gobalThis !== 'undefined' ? globalThis : window).gySVG.extend (plugin);
